export default __webpack_public_path__ + "/dist/images/member.372a1d8702cf31d2dbd3e73f1089eb15.svg";